export default "__VITE_PUBLIC_ASSET__b20354c2__"